import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { DatabaseProvider } from '../database/database';
import { SQLiteObject } from '@ionic-native/sqlite';

@Injectable()
export class ParametroProvider {


  constructor(public dbProvider: DatabaseProvider) {

  }

  async insert(data) {
    this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        db.transaction(async (tx) => {
          let sql = 'insert into parametros(Par_Codigo, Par_Tipo, Par_Valor) values (?, ?, ?)';
          for (let val of data) {
            let parametro = new Parametro();
            parametro.codigo = val.Par_Codigo;
            parametro.tipo = val.Par_Tipo;
            parametro.valor = val.Par_Valor;
            let params = [parametro.codigo, parametro.tipo, parametro.valor];

            await tx.executeSql(sql, params, (tx, resultSet) => {
              console.log('importou parâmetro');
            }, (err) => {
              console.log('erro:' + err);
            });

          }
        }).then();

      })
      .catch((e) => console.error(e));
  }

  public removeAll() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'delete from parametros';
        let data = [];

        return db.executeSql(sql, data)
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  public getAll() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM parametros';

        return db.executeSql(sql, [])
          .then((data: any) => {
            if (data.rows.length > 0) {
              let parametros: any[] = [];
              for (var i = 0; i < data.rows.length; i++) {
                var parametro = data.rows.item(i);
                parametros.push(parametro);
              }
              return parametros;
            } else {
              return [];
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  maxDesconto() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM parametros WHERE Par_Codigo = ?';

        return db.executeSql(sql, ['00204'])
          .then((data: any) => {
            if (data.rows.length > 0) {
              return data.rows.item(0).Par_Valor;
            } else {
              return 0;
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  usaTabelaPreco() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM parametros WHERE Par_Codigo = ?';

        return db.executeSql(sql, ['00223'])
          .then((data: any) => {
            if (data.rows.length > 0) {
              return data.rows.item(0).Par_Valor == 1;
            } else {
              return false;
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }


  alteraPreco() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM parametros WHERE Par_Codigo = ?';

        return db.executeSql(sql, ['00406'])
          .then((data: any) => {
            if (data.rows.length > 0) {
              return data.rows.item(0).Par_Valor == 1;
            } else {
              return false;
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  informaPagamento() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM parametros WHERE Par_Codigo = ?';

        return db.executeSql(sql, ['IFPAD'])
          .then((data: any) => {
            if (data.rows.length > 0) {
              return data.rows.item(0).Par_Valor == 1;
            } else {
              return false;
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }

  informaRota() {
    return this.dbProvider.getDB()
      .then((db: SQLiteObject) => {
        let sql = 'SELECT * FROM parametros WHERE Par_Codigo = ?';

        return db.executeSql(sql, ['IFROT'])
          .then((data: any) => {
            if (data.rows.length > 0) {
              return data.rows.item(0).Par_Valor == 1;
            } else {
              return false;
            }
          })
          .catch((e) => console.error(e));
      })
      .catch((e) => console.error(e));
  }
}


export class Parametro {
  codigo: string;
  tipo: string;
  valor: string;
}



// WEBPACK FOOTER //
// ./src/providers/parametro/parametro.ts